// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-table[data-v-2b983e7a] {\n  padding-left: 50px;\n}\n.form-conrtol[data-v-2b983e7a] {\n  width: 100%;\n}\n[data-v-2b983e7a] .vxe-body--column {\n  height: 50px !important;\n}\n[data-v-2b983e7a] .el-pagination.is-background .el-pager li:not(.disabled).active {\n  color: white !important;\n}\n", ""]);
// Exports
module.exports = exports;
